export default {
      id: "sli-send-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.b3fb107f.svg#sli-send",
      toString: function () {
        return this.url;
      }
    }